// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2Kyte","boxTitle":"Qualiphy_boxTitle__304_Y","box":"Qualiphy_box__2FKXt","toggleWrap":"Qualiphy_toggleWrap__5yiJS"};